import React from "react";
import PropTypes from "prop-types";
import { Label } from "@cars24/turbo-web/lib/label";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { PDI_CAR_TYPE } from "../../../constants/pre-delivery-inspection-constants";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiUserIntent } from "../../../constants/tracking-constants/pre-delivery-inspection";
import PdiIntentCard from "../../shared/pdi-intent-card";
import { NEW_PDI_ROUTES } from "./constant";
import styles from "./styles.css";

const PreDeliveryInspectionIntent = ({
    cmsDetails,
    details
}) => {
    const { tokens } = useTokens();
    const { title: carTypeTitle = "" } = details?.subSections?.[0] || {};
    const { carTypeList = [] } = cmsDetails || {};

    const handleCheck = async (widgetName = "") => {
        await yieldToMain();
        sendCustomGaEvents({
            ...pdiUserIntent,
            ...(widgetName === PDI_CAR_TYPE.NEW_CAR && {
                event: "new_car_selected",
                eventAction: "new_car_selected"
            })
        });
    };

    return (
        <div styleName={"styles.pdiIntentWrapper"}>
            <div styleName={"styles.titles"}>
                <Label level={NUMBER.ONE} fontWeight="semibold" color={tokens.text_default_text_primary}>{carTypeTitle}</Label>
            </div>
            <div styleName={"styles.intentSection"}>
                {!!(carTypeList && carTypeList.length) && carTypeList.map((item, index) => (
                    <PdiIntentCard
                        {...item}
                        href={NEW_PDI_ROUTES[item?.widgetName] || ""}
                        key={`pre-delivery-inspection-intent-${index}`}
                        index={index}
                        isDesktop={true}
                        handleCheck={handleCheck}
                    />
                ))}
            </div>
        </div>
    );
};

PreDeliveryInspectionIntent.propTypes = {
    history: PropTypes.any,
    newCarPdiLead: PropTypes.bool,
    setDetailsConnect: PropTypes.func,
    cmsDetails: PropTypes.object,
    persist: PropTypes.object,
    isPdiLeadSelected: PropTypes.bool,
    details: PropTypes.object
};

export default PreDeliveryInspectionIntent;
